import { styled } from "../stitches.config";
import { FiCalendar, FiCheckCircle, FiInbox } from 'react-icons/fi';


export const NavButton = styled('button', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center', 
    gap: '0.5rem', 
    padding: '0.75rem 0',

    flex: 1, 
    position: 'relative',
    background: '$blueWeeks',
    fontSize: '$md',
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: 'none',
    borderTopLeftRadius: '16px', 
    borderTopRightRadius: '16px',
    transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
    '&svg': {
        width: '40px',
        height: '40px',
        transition: 'stroke 0.2s ease',

    }, 
    variants: {
        active: {
            true: {
                background: '$blueHover',
                fontWeight: 600,
                borderTop: '1px solid $separator',
                borderLeft: '1px solid $separator',
                borderRight: '1px solid $separator',
                color: 'var(--colors-blue11)',
                boxShadow: '0 4px 12px -2px rgba(0, 0, 0, 0.1)',
                '& svg': {
                    stroke: 'var(--colors-blue11)', // Changes stroke color when active
                }
            },
            false: {
                // borderBottom: '1px solid var(--colors-blue11)'
                borderBottom: '1px solid $separator',
            }
        },


        
          },

          '&:hover': {
            backgroundColor: '$blueHover',
            color: 'var(--colors-blue11)',
            '& svg': {
              stroke: 'var(--colors-blue11)',
            },
    },

});

export const CalendarIcon = styled(FiCalendar, {
    // stroke: 'var(--colors-blue11)',
    // gap: '1rem',
});


export const CompletedIcon = styled(FiCheckCircle, {
    // stroke: 'var(--colors-blue11)',
    gap: '1rem',
});


export const ConfirmIcon = styled(FiInbox, {
    // stroke: 'var(--colors-blue11)',
    gap: '1rem',
});


// CalendarBadge.tsx
export const Badge = styled('div', {
    // make it a shrinkable flex item
    flex: '0 1 14rem',      // preferred 14rem, can shrink
    minWidth: '8rem',       // don’t get too tiny (tune as you like)
    maxWidth: '45%',        // avoid hogging space on large cards
  
    aspectRatio: '1 / 1',
    borderRadius: '16px',
    border: '3px solid $gray3',
    // background: '$green2',
    background: '$blue1',

    position: 'relative',
    display: 'grid',
    placeItems: 'center',
  
    // allow font sizes to respond to this element’s width
    // (enables cqw/cqh units)
    containerType: 'inline-size',
  
    '@media (max-width: 800px)': {
      flex: '0 1 11rem',
      minWidth: '7rem',
      maxWidth: '40%',
    },
  });
  
  export const Day = styled('div', {
    fontWeight: 800,
    color: '$gray12',
    lineHeight: 1,
  
    // scale with the badge width (container query units)
    fontSize: 'clamp(1.25rem, 28cqw, 3rem)',
  
    // fallback for browsers without cqw
    '@supports not (font-size: 1cqw)': {
      fontSize: 'clamp(1.25rem, 8vw, 3rem)',
    },
  
    marginTop: '8%',
  });
  

/* top colored bar */
export const TopBar = styled('div', {
  position: 'absolute',
  borderTopLeftRadius: '16px',
  borderTopRightRadius: '16px',
  top: 0,
  left: 0,
  right: 0,
  height: '28%',
  background: '$blueWeeks',
  // background: '$green3',
  borderBottom: '1px solid $gray6',
});

/* binder posts */
export const Posts = styled('div', {
  position: 'absolute',
  top: '-6px',
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0 18%',
});
export const Post = styled('div', {
  width: '10px',
  height: '14px',
  borderRadius: '4px',
  background: '$gray12',
});

/* date text */
// const Day = styled('div', {
//   fontWeight: 800,
//   color: '$gray12',
//   lineHeight: 1,
//   fontSize: 'clamp(1.75rem, 8vw, 3.5rem)',
//   marginTop: '8%', // keep it visually centered below the bar
// });

export const Month = styled('div', {
  position: 'absolute',
  bottom: '10%',
  fontSize: '$xs',
  color: '$gray10',
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
});



export const ModalOverlay = styled('div', {
  position: 'fixed',
  top: 0, left: 0,
  width: '100%', height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  justifyContent: 'center', alignItems: 'center',
  zIndex: 1000,
  transition: 'opacity 0.3s ease-in-out',
  variants: {
    isOpen: {
      true: { display: 'flex', opacity: 1 },
      false:{ display: 'none', opacity: 0 }
    }
  },
  defaultVariants: { isOpen: false }
});

export const ModalContainer = styled('div', {
  background: 'white',
  borderRadius: '16px',
  width: '90%', maxWidth: '600px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  display: 'flex', flexDirection: 'column',
  overflow: 'hidden',
  transition: 'all 0.3s ease-in-out',
});

export const ContentWrapper = styled('div', { padding: '1.5rem' });

export const ModalHeader = styled('div', {
  paddingBottom: '1rem',
  borderBottom: '1px solid $separator',
  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  fontWeight: 600,
});

export const CloseButton = styled('button', {
  background: 'none', border: 'none', cursor: 'pointer',
  padding: '0.5rem', borderRadius: '50%',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  transition: 'background-color 0.2s',
  '&:not([data-active="true"]):hover': {
        backgroundColor: '$blueHover',
        // The 'color' property is removed, so it stays black

        '& svg': {
        fill: 'var(--colors-blue11)',
        // stroke: 'var(--colors-blue11)',
      },  
      },
  
});

export const StepContent = styled('div', {
  flexGrow: 1,
  paddingTop: '1rem', paddingBottom: '1rem',
  overflowY: 'auto',
  maxHeight: '50vh',
  fontSize: '$md',
});

export const ModalFooter = styled('div', {
  padding: '1rem 1.5rem',
  borderTop: '1px solid #e5e7eb',
  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  backgroundColor: '#f9fafb',
});

// UPDATED: ActionButton gets micro-animation + a background (ghost) variant
export const ActionButton = styled('button', {
  padding: '0.6rem 1.2rem',
  borderRadius: '8px',
  border: '1px solid transparent',
  fontWeight: 500, cursor: 'pointer',
  fontSize: '$md',
  transition: 'transform 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, opacity 0.2s',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.4rem',

  '&:not(:disabled):hover': { transform: 'scale(1.05)' },
  '&:not(:disabled):active': { transform: 'scale(0.98)' },
  '&:disabled': { opacity: 0.5, cursor: 'not-allowed' },

  variants: {
    intent: {
      background: {
        backgroundColor: 'transparent',
        border: 'none',
        padding: '0.25rem',
        '&:hover': { backgroundColor: 'transparent' },
      },
    }
  },
});

export const PrimaryButton = styled(ActionButton, {
  backgroundColor: '#3b82f6', color: 'white', borderColor: '#3b82f6',
  '&:hover:not(:disabled)': { backgroundColor: '#2563eb' }
});

export const SecondaryButton = styled(ActionButton, {
  backgroundColor: 'white',
  color: '#374151',
  borderColor: '#d1d5db',
  borderWidth: '1px',
  '&:hover:not(:disabled)': { backgroundColor: '#f9fafb', borderColor: '#9ca3af' }
});

export const FormGroup = styled('div', {
  marginBottom: '1.5rem',
  variants: {
    removeSeparator: {
      false: {
        borderTop: '1px solid $separator',
        marginTop: '2rem',
        paddingTop: '1.5rem',
      },
      true: {}
    }
  },
  defaultVariants: {
    removeSeparator: 'false',
  },
});

export const Label = styled('label', {
  display: 'block',
  fontWeight: 500,
  color: '#374151',
  marginBottom: '0.5rem',
});

export const Input = styled('input', {
  width: '100%',
  padding: '0.75rem',
  border: '1px solid #d1d5db',
  borderRadius: '8px',
  fontSize: '$md',
  boxSizing: 'border-box',
  '&:focus': {
    outline: 'none',
    borderColor: '#3b82f6',
    boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.4)',
  },
  '&::-webkit-calendar-picker-indicator': { pointerEvents: 'none' },
});

export const ChoiceButtonGroup = styled('div', {
  display: 'flex', gap: '1rem', marginTop: '1.5rem',
});

export const ChoiceButton = styled('button', {
  flexGrow: 1,
  padding: '1rem',
  fontWeight: 500,
  borderRadius: '8px',
  border: '1px solid #d1d5db',
  cursor: 'pointer',
  transition: 'all 0.2s',
  fontSize: '$md',
  '&:hover': { borderColor: '#3b82f6' },
  variants: {
    isSelected: {
      true: {
        borderColor: '#3b82f6',
        backgroundColor: '#eff6ff',
        color: '#2563eb',
      },
      false: {
        backgroundColor: 'white',
        color: '#374151',
      }
    }
  },
  defaultVariants: { isSelected: false }
});

export const DateTimePreview = styled('div', {
  marginTop: '2rem',
  fontStyle: 'italic',
  fontSize: '$md',
  color: 'var(--colors-blue11)',
  textAlign: 'center',
  transition: 'opacity 0.3s ease-in-out',
});

// NEW: compact icon button for per-row edit toggles
export const HeaderIconButton = styled('button', {
  all: 'unset',
  display: 'grid',
  placeItems: 'center',
  cursor: 'pointer',
  width: '2rem',
  height: '2rem',
  borderRadius: '50%',
  color: '$sand11',
  transition: 'background-color 0.2s ease, color 0.2s ease, transform 0.15s ease',


  '&:hover': {
    backgroundColor: '$blueHover',
    '& svg': {
      fill: 'var(--colors-blue11)', // Make the icon blue on hover
    },
  },

  '&:active': { transform: 'scale(0.96)' },
});

export const ResultsGrid = styled('div', {
  display: 'grid',
  gap: '1.5rem',
  justifySelf: 'center',
  width: 'min(75%, 1200px)', // keeps it from getting too wide on big screens
  '@media (max-width: 900px)': {
    width: '100%',

  },

  marginInline: 'auto',   // <— center the 75% block in all browsers
})

export const List = styled('div', {
  display: 'grid',
  gap: '1rem',
  marginTop: '1rem',

});

export const TopRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  position: 'sticky',
  top: 0,
  zIndex: 1,
});

export const Spacer = styled('div', { flex: 1 });

export const ViewToggle = styled('div', {
  display: 'inline-flex',
  border: '1px solid $gray6',
  borderRadius: 999,
  overflow: 'hidden',
  background: 'white',
});

export const ToggleBtn = styled('button', {
  all: 'unset',
  padding: '0.4rem 0.9rem',
  fontSize: '$sm',
  cursor: 'pointer',
  '&:hover': { background: '$blueHover' },
  variants: {
    active: {
      true: {
        background: '$blue3',
        color: '$blue11',
        fontWeight: 600,
      },
    },
  },
});

// In your component's style file, near the other components

export const BackButton = styled('button', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
  all: 'unset',
  cursor: 'pointer',
  padding: '0.4rem 0.8rem',
  borderRadius: 8,
  border: '1px solid var(--colors-gray6)',
  background: 'white',
  '&:hover': { background: '$gray2' },
});

export const Overlay = styled('div', {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, overscrollBehavior: 'none',
});

export const Dialog = styled('div', {
  width: 'min(920px, 96dvw)', maxHeight: '90dvh', overflow: 'auto', background: 'white', borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.25)', overscrollBehavior: 'none',
});